<script setup>
import { computed, onMounted, onUnmounted, ref } from "vue";

const INTERVAL = 60 * 1000;
const SECONDS_IN_MINUTE = 60;
const SECONDS_IN_HOUR = SECONDS_IN_MINUTE * 60;
const SECONDS_IN_DAY = SECONDS_IN_HOUR * 24;

const getTimeLeft = date => {
  const curTime = Date.now();
  const endTime = new Date(date).getTime();
  return Math.max(0, Math.floor((endTime - curTime) / 1000));
};

const props = defineProps({
  deadline: {
    type: String,
    required: true
  },
  onTimeout: {
    default: () => {},
    type: Function
  },
  short: {
    type: Boolean,
    default: false
  }
});

const timerDiff = ref(getTimeLeft(props.deadline));
const formatTimer = computed(() => {
  const days = Math.floor(timerDiff.value / SECONDS_IN_DAY);
  const hours = Math.floor(timerDiff.value / SECONDS_IN_HOUR) - days * 24;
  const minutes = Math.floor(timerDiff.value / SECONDS_IN_MINUTE) - (days * 24 + hours) * 60;

  let text = "";

  if (days) {
    text += `${days} day${days === 1 ? "" : "s"} `;
  }
  if (hours) {
    text += `${hours} hr${hours === 1 ? "" : "s"} `;
  }
  if (minutes) {
    text += `${minutes} min`;
  }
  if (text === "") {
    text = "less then a minute";
  }

  return text;
});

onMounted(() => {
  const timer = setInterval(() => {
    timerDiff.value = getTimeLeft(props.deadline);

    if (timerDiff.value === 0) {
      props.onTimeout();
    }
  }, INTERVAL);

  onUnmounted(() => {
    clearInterval(timer);
  });
});
</script>

<template>
  <div class="delivery-date-time-left">
    <span class="delivery-date-time-left__title">
      If ordered in<span v-if="!short">&nbsp;the next</span>
    </span>
    {{ " " }}
    <strong class="delivery-date-time-left__timer">{{ formatTimer }}</strong>
  </div>
</template>

<style scoped lang="scss">
.delivery-date-time-left {
  font-size: 11px;
  text-align: center;

  &__title {
    margin-right: 2px;
    letter-spacing: -0.2px;
  }

  &__timer {
    font-weight: 600;
  }
}
</style>
